import React, { createContext, useContext, useState, useCallback } from 'react';

const OrderEventsContext = createContext({ triggerRefreshOrders: () => {}, refreshKey: 0 });

export function useOrderEvents() {
  return useContext(OrderEventsContext);
}

export function OrderEventsProvider({ children }) {
  const [refreshKey, setRefreshKey] = useState(0);

  const triggerRefreshOrders = useCallback(() => {
    setRefreshKey(Date.now());
  }, []);

  return (
    <OrderEventsContext.Provider value={{ triggerRefreshOrders, refreshKey }}>
      {children}
    </OrderEventsContext.Provider>
  );
}